import { HistoryItem } from '.'

export type Action = 'play' | 'asinChanged' | 'closed'

const ANALYTICS_URL = '/gp/video/widgets/main-section/ajax/analytics.html/ref='

export const logAction = (action: Action) => (opts: HistoryItem) => {
  if (!opts) {
    return
  }
  const { trailer, asin, lcid, startEpoch } = opts
  const refTag = 'dv_play_action'
  const secondsPlayed =
    action !== 'play' && startEpoch
      ? Math.floor(new Date().getTime() / 1000) - startEpoch
      : null

  fetch(
    `${ANALYTICS_URL}${refTag}?trailer=${trailer}&action=${action}&titleId=${asin}${
      secondsPlayed !== null ? `&secondsPlayed=${secondsPlayed}` : ''
    }${lcid ? `&lcid=${lcid}` : ''}`
  )
}

export const sendStartPlaybackAnalytics = (refTag: string) => {
  fetch(`${ANALYTICS_URL}${refTag}`)
}
